import { ProductDetails } from "@/sdk/types";

export async function getProducts(idsToFetch: string[]) {
  const productPromises = idsToFetch.map((id) =>
    (window as any).helium.datastore
      .getProduct({ id })
      .catch((error: unknown) => {
        console.error(`Error fetching product ${id}:`, error);
        return null; // Return null for failed fetches
      }),
  );

  const productsResults = await Promise.all(productPromises);

  // Filter out null results and extract details
  const fetchedProducts = productsResults
    .map((result) => result?.details)
    .filter(Boolean) as ProductDetails[];
  return fetchedProducts;
}
